import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import type ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'

export const getCustomFieldKey = (customField: ResourceField) => {
  return `cf-${customField.attributes.identifier}`
}

const customFieldTypeToFormType = (type: string) => {
  switch (type) {
    case FieldTypes.text:
    case FieldTypes.longText:
    case FieldTypes.singleChoice:
      return 'string'
    default:
      return type
  }
}

export const customFieldsFormKeys = (customFields: ResourceField[]) => {
  const formKeys: { [key: string]: string } = {}

  return customFields.reduce((formKeys, field) => {
    const key = getCustomFieldKey(field)
    formKeys[key] = customFieldTypeToFormType(field.attributes.field_type)
    return formKeys
  }, formKeys)
}
